import { next } from '@ember/runloop';

import { modifier } from 'ember-modifier';

import { isElementOnScreen } from 'webapp/utils/html';

import { itemDomClass, itemEventName } from 'webapp/modifiers/visible-check-container';

// Used together with modifiers/visible-check-container
// Check that one for more info
// checkImmediately should be set to false if we use mixitup and we have afterFilter fn set

const visibleCheckItem = (
	node: HTMLElement,
	[
		onVisibleChange,
		checkImmediately = true,
		lookForwardPx = 300,
		lookBackwardPx = 300,
		hideWhenNotVisible = false,
	]: [(v: boolean) => void, boolean?, number?, number?, boolean?],
) => {
	let isVisible = false;

	const checkVisibility = (e?: CustomEvent<{ scrollContainerNode?: HTMLElement } | null>) => {
		if (node.offsetParent === null) {
			// means it's hidden https://stackoverflow.com/a/21696585
			return;
		}
		const scrollContainerNode =
			e?.detail?.scrollContainerNode || node.closest<HTMLElement>('.popup') || window;

		// Check if element is currently visible with both forward and backward checking
		const isNowVisible = isElementOnScreen(
			node,
			scrollContainerNode,
			lookForwardPx,
			lookForwardPx,
			hideWhenNotVisible, // includeScrolledPast - check both forward and backward directions
			lookBackwardPx,
			lookBackwardPx,
		);

		if (isVisible !== isNowVisible) {
			const rect = node.getBoundingClientRect();

			isVisible = isNowVisible;
			onVisibleChange(isNowVisible);

			// If transitioning from visible to hidden, capture dimensions and apply to placeholder
			next(() => {
				if (!isVisible) {
					const placeholder = node.querySelector<HTMLElement>(
						'.visible-check__item-placeholder',
					);

					if (placeholder) {
						placeholder.style.width = `${rect.width}px`;
						placeholder.style.height = `${rect.height}px`;
					}
				}
			});
		}
	};

	node.classList.add(itemDomClass);

	if (checkImmediately) {
		checkVisibility();
	}

	node.addEventListener(itemEventName, checkVisibility as EventListener);

	return () => {
		node.removeEventListener(itemEventName, checkVisibility as EventListener);
	};
};

const visibleCheckItemModifier = modifier(visibleCheckItem);

export default visibleCheckItemModifier;
